import compo from "./urGrid"
import cItem from "./urGridItem"

export default {
    install(Vue) {
        Vue.component(compo.name, compo);
        Vue.component(cItem.name, cItem);
    }
};
